"use client";

import { usePathname, useSearchParams } from "next/navigation";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect, type JSX } from "react";
import configuration from "~/configuration";

// app/providers.tsx

if (typeof window !== "undefined") {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const posthogHost =
    process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://app.posthog.com";

  const shouldInitPosthog = configuration.environment === "production";

  if (posthogKey && shouldInitPosthog) {
    try {
      posthog.init(posthogKey, {
        api_host: posthogHost,
        capture_pageview: false, // Disable automatic pageview capture, as we capture manually
        person_profiles: "always",
      });
    } catch (error) {
      console.error("Error initializing PostHog", error);
    }
  } else {
    console.warn("PostHog key and host must be defined");
  }
}

export function PostHogPageview(): JSX.Element {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      let url = window.origin + pathname;
      if (searchParams && searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return <></>;
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
